const formatNumberToK = (num: number): string => {
    if (!num) {
        return '';
    }
    
    if (num < 1000) {
        return num.toString();
    }

    const thousands = num / 1000;
    const rounded = Math.round(thousands * 10) / 10;
    const formatted = rounded % 1 === 0 ? rounded.toFixed(0) : rounded.toFixed(1);

    return `${formatted}k`;
};

export default formatNumberToK;
